// @ts-nocheck
import { useEffect, useState, useRef } from "react";
import './FileQueue.scss'
import { CollapseSvg, PinSvg, FilequeueSvg, TaskCompleteSvg, TaskOngoingSvg, TaskUpcommingSvg, DownloadSvg, FilequeueSvgWhite } from "../Svgs";
import Modal from "../Modal";
import useModals from "../../../../hooks/useModals";
import { Resizable } from 'react-resizable';
import CustomToolTip from "../../../../../CommonComponents/CustomToolTip";
import useUrlParams from "../../../../hooks/useUrlParams";
import { CircularProgress } from '@mui/material';
import CommandCenterService from "../../../../../../service/CommandCenterService";
import { downloadFile, navigateTo } from "../../../../../../utils/commonFunctions";
import useDownloadFile from "../../../../hooks/useDownloadFiles";
import EmptyPage from "../../../../custom_components/EmptyPage";
import { get_formated_time } from "../../../../utils";
import useTrueTwin from "../../../../hooks/useTrueTwin";
import { Modals } from "../../../../types";
import useUrlNavigation from "../../../../hooks/useUrlNavigation";
import useFiles from "../../../../hooks/useFiles";
import { OngoingProgress, RefreshButton } from "../../Files/Svgs";
import useContacts from "../../../../hooks/useContacts";
import ShimmerMenuList from "../../../../../CommonComponents/ShimmerEffectDesign/ShimmerMenu";
import useScenario from "../../../../hooks/useScenario";
import { isOperateMode } from "../../../../hooks/utils";
import { SCENARIO_DEPLOYMENT_TYPES } from "../../../../../simulate/constants";

const FileQueue = () => {
    const { truetwin_id } = useTrueTwin()
    const { dashboard } = useUrlParams()
    const { scenario } = useScenario()
    const deploymentType = (scenario?.scenarioDeploymentType ?? '').toUpperCase();
    const isValidateSummary = deploymentType === SCENARIO_DEPLOYMENT_TYPES.VALIDATE && dashboard === 'summary';
    const operateMode = isOperateMode(dashboard, scenario)
    const { downloadFiles } = useDownloadFile()
    const [resizing, setResizing] = useState(false)
    const [height, setHeight] = useState(300)
    const [openUploadFile, setOpenUploadFile] = useState<string | boolean>(false)
    const [fileDownloading, setFileDownloading] = useState<string | boolean>(false)
    const [isRefreshIconEnable, setIsRefreshIconEnable] = useState(false)
    const [expand, setExpand] = useState(false);
    const [hover, setHover] = useState(false);
    const { contacts } = useContacts();
    const { ongoing_contacts } = contacts;
    const { open_modal, close_modal, pinned_modal, get_modal_details, close_all_unpinned_modals } = useModals()
    const modal: Modals = get_modal_details('filequeue')
    const { navigate_to, navigate_dashboard } = useUrlNavigation()
    const { allACPStorageFiles, allDownlinkingFiles, isDownlinkqueueLoading, refreshQueue } = useFiles()
    const modalContainerRef = useRef<HTMLDivElement>(null);

    const onResize = (event, { node, size, handle }) => {
        event.stopPropagation()
        if (size.height >= 150 && size.height <= 550) {
            setHeight(size.height);
        }
    };

    const onResizeStart = (events) => {
        events.stopPropagation()
        setResizing(true);
    }
    const onResizeStop = (events) => {
        events.stopPropagation()
        setResizing(false);
    }

    // HANDLE ENABLING OF REFRESH ICON BASED ON ACTIVE CONTACT
    useEffect(() => {
        if (!ongoing_contacts || ongoing_contacts.length === 0) {
            setIsRefreshIconEnable(false)
        } else {
            setIsRefreshIconEnable(true)
        }
    }, [ongoing_contacts])

    useEffect(() => {
        const close_open_modal = (event: Event) => {
            // Don't close if clicking inside the filequeue container
            if (event.target instanceof Element && modalContainerRef.current?.contains(event.target)) return
            
            const currentModal = get_modal_details('filequeue')
            // Close filequeue if it's open and NOT pinned
            if (currentModal.open && !currentModal.pinned) {
                close_modal('filequeue')
            }
        }
        // Use capture phase to ensure this fires before other handlers
        document.addEventListener('click', close_open_modal, true)
        return () => {
            document.removeEventListener('click', close_open_modal, true)
        }
    }, [get_modal_details, close_modal])

    const getIcon = (status: string, progress?: number) => {
        switch (status) {
            case 'Completed':
                return <TaskCompleteSvg />;

            case 'Uplinking':
                return <OngoingProgress progress={progress ?? 0} />;

            case 'download_inprogress':
                return <OngoingProgress progress={progress} />;

            case 'download_pending':
                return <TaskUpcommingSvg />;

            default:
                return <TaskUpcommingSvg />;
        }
    };

    const get_true_twin_file_content_from_datastore = (file: any,) => {
        setFileDownloading(file?.['name'])
        CommandCenterService.getTrueTwinDataStoreFilecontent(truetwin_id, file?.['name'])?.then((data) => {
            if (data && data.data) {
                downloadFile(data?.data, file?.['name'])
                setFileDownloading('')
            }
        }).catch((err) => {
            console.error(err);
            setFileDownloading('')
        });
    }

    //HANDLE REFRESHING DOWNLINK QUEUE
    const handleRefresh = () => {
        if (!isRefreshIconEnable) return;
        refreshQueue(truetwin_id);
    }

    return (
        <Modal
            open={modal.open}
            pinned={modal.current_modal === 'filequeue' && modal.pinned}
            disabled={modal.current_modal === 'filequeue' && modal.pinned || resizing}
            class_name={`${modal.current_modal === 'filequeue' ? 'current__modal' : ''}`}
        >
            <div
                ref={modalContainerRef}
                className={`filequeue__panel__container ${expand && 'expand'} `}
                onClick={(event: any) => {
                    event.stopPropagation()
                    open_modal('filequeue')
                }}>
                <div className="filequeue__panel__header">
                    <div className=" d-flex align-items-center gap-2">
                        <FilequeueSvg color={"#F0F0F0"} />
                        <span className="panel__header__title">Files</span>
                    </div>
                    <div className=" d-flex align-items-center">
                        <button className="panel__colapse__btn" onClick={(event: any) => {
                            event.stopPropagation()
                            setExpand(!expand)
                        }}>
                            <CollapseSvg />
                        </button>
                        <button className={`panel__pin__btn ${modal.pinned ? 'pinned' : ''}`}
                            onClick={(event: any) => {
                                event.stopPropagation()
                                pinned_modal('filequeue')
                            }}>
                            <PinSvg />
                        </button>
                        <button className={`panel__close__btn`}
                            onClick={(event: any) => {
                                event.stopPropagation()
                                close_modal('filequeue')
                            }}>
                            <i className="fe fe-x fs-16" />
                        </button>
                    </div>
                </div>
                <div className={`filequeue__panel__body ${isValidateSummary ? 'readonly-summary' : ''}`} >

                    {/* UPLINK QUEUE */}
                    {operateMode && (
                        <Resizable
                            className="position-relative"
                            width={expand ? 800 : 350}
                            height={height}
                            onResizeStop={onResizeStop}
                            onResizeStart={onResizeStart}
                            onResize={onResize}
                            handle={(handleAxis, ref) => (
                                <div ref={ref as React.Ref<HTMLDivElement>} className={`resize__handler handle-${handleAxis}`} />
                            )}
                        >
                            {/* FILE UPLINK QUEUE */}
                            <div className="file__upload__section" style={{ height: '50%' }}>
                                <span className="queue-color">Uplink Queue</span>

                                {allACPStorageFiles && allACPStorageFiles?.['uplink-files'].size > 0 && (
                                    <div className="file__upload__scroll__section">
                                        {Array.from(allACPStorageFiles?.['uplink-files']?.values() || [])
                                            .filter((f) => f.fileStatus === "Uplinking" || f.fileStatus === "Completed")
                                            .map((file) => {
                                                const status = file?.fileStatus;
                                                const fileId = file?.uniqueId;

                                                return (
                                                    <div
                                                        className={`file__details__container ${status} ${openUploadFile === fileId && 'active'}`}
                                                        key={file.uniqueId}
                                                        onClick={() => {
                                                            navigate_to('files-ground-files');
                                                            close_modal('filequeue');
                                                        }}
                                                    >
                                                        <div className="file__details__header">
                                                            <div
                                                                className="d-flex align-items-center gap-2 w-50"
                                                                style={{ width: '24px', height: '24px' }}
                                                            >
                                                                <div
                                                                    className="d-flex align-items-center justify-content-center"
                                                                    style={{ height: '32px', width: '32px' }}
                                                                >
                                                                    {getIcon(status, file?.progress)}
                                                                </div>
                                                                <span className="file__title">
                                                                    <CustomToolTip title={file?.fileName} placement="top">
                                                                        {file?.fileName}
                                                                    </CustomToolTip>
                                                                </span>
                                                            </div>
                                                            <div className="d-flex align-items-center justify-content-end w-50 gap-2">
                                                                <span className="file__time">
                                                                    <CustomToolTip title={file?.lastModified} placement="top">
                                                                        {file?.lastModified}
                                                                    </CustomToolTip>
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className="file__details__body"></div>
                                                    </div>
                                                );
                                            })}
                                    </div>
                                )}

                                {Array.from(allACPStorageFiles?.['uplink-files']?.values() || [])
                                    .filter((f) => f.fileStatus === "Uplinking" || f.fileStatus === "Completed")
                                    .length === 0 && (
                                        <div className="h-100 w-100 align-items-center">
                                            <EmptyPage content_type="file" content={expand ? "Uplink Queue is Empty" : ''} />
                                        </div>
                                    )}
                            </div>
                        </Resizable>
                    )}


                    {/* DOWNLINK QUEUE */}
                    {operateMode && (
                        <Resizable
                            className="position-relative"
                            width={expand ? 800 : 350}
                            height={height}
                            onResizeStop={onResizeStop}
                            onResizeStart={onResizeStart}
                            onResize={onResize}
                            handle={(handleAxis, ref) => (
                                <div ref={ref as React.Ref<HTMLDivElement>} className={`resize__handler handle-${handleAxis}`} />
                            )}
                        >
                            {/* FILE DOWNLINK QUEUE */}
                            <div className="file__upload__section" style={{ height: '50%' }}>
                                <div className="d-flex queue-color justify-content-between">
                                    Downlink Queue
                                    {/* Refresh Section */}
                                    <div className={`file-tab-downlink-queue-refresh-container`}>

                                        {/* Info Tooltip */}
                                        <div
                                            id="file-tab-refresh-info-div"
                                            className={`file-tab-refresh-info-card ${hover ? "active" : ""} ${isRefreshIconEnable ? 'small' : ''}`}
                                        >
                                            <div className="file-tab-refresh-info-card-text">
                                                {isRefreshIconEnable
                                                    ? "Refresh Status"
                                                    : "Status can be refreshed only when in contact"}
                                            </div>
                                        </div>

                                        {/* Refresh Icon */}
                                        <div
                                            className={`file-tab-downlink-queue-refresh-icon ${isRefreshIconEnable ? "" : "disabled"}`}
                                            onMouseEnter={() => setHover(true)}
                                            onMouseLeave={() => setHover(false)}
                                            onClick={handleRefresh}
                                        >
                                            <RefreshButton />
                                        </div>
                                    </div>

                                </div>
                                {isDownlinkqueueLoading ? (<ShimmerMenuList rowHeight={44} reducedRows={11} /> // SHOW SHIMMER WHEN LOADING
                                ) : allDownlinkingFiles && allDownlinkingFiles.size > 0 ? (
                                    <div className="file__upload__scroll__section">
                                        {Array.from(allDownlinkingFiles.values() || [])
                                            .filter(
                                                (file) =>
                                                    file.status === "download_inprogress" ||
                                                    file.status === "download_pending"
                                            )
                                            .map((file) => {
                                                const status = file.status;
                                                const fileId = file.uniqueId;
                                                return (
                                                    <div
                                                        className={`file__details__container ${openUploadFile === fileId && 'active'}`}
                                                        key={file?.uniqueId}
                                                        onClick={() => {
                                                            navigate_to('files-onboard-files');
                                                            close_modal('filequeue');
                                                        }}
                                                    >
                                                        <div className="file__details__header">
                                                            <div
                                                                className="d-flex align-items-center gap-2 w-50"
                                                                style={{ width: '24px', height: '24px' }}
                                                            >
                                                                <div
                                                                    className="d-flex align-items-center justify-content-center"
                                                                    style={{ height: '32px', width: '32px' }}
                                                                >
                                                                    {getIcon(status, file?.progress)}
                                                                </div>
                                                                <span className="file__title">
                                                                    <CustomToolTip title={file?.fileName} placement="top">
                                                                        {file?.fileName}
                                                                    </CustomToolTip>
                                                                </span>
                                                            </div>
                                                            <div className="d-flex align-items-center justify-content-end w-50 gap-2">
                                                                <span className="file__time">
                                                                    <CustomToolTip title={file?.updatedAt} placement="top">
                                                                        {file?.updatedAt}
                                                                    </CustomToolTip>
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className="file__details__body"></div>
                                                    </div>
                                                );
                                            })}
                                    </div>
                                ) : (
                                    <div className="h-100 w-100 align-items-center">
                                        <EmptyPage
                                            content_type="file"
                                            content={expand ? 'Downlink Queue is Empty' : ''}
                                        />
                                    </div>
                                )}
                            </div>
                        </Resizable>
                    )}

                    {/* HWIL DOWNLOAD SECTION --> ONLY FOR SIMULATE */}
                    <div className={`file__download__section ${operateMode ? 'd-none' : ''}`}>
                        <span className="color-atmos">List of Files</span>
                        {downloadFiles?.length > 0 &&
                            <div className="file__download__scroll__section">
                                {downloadFiles.map((file: { name: string, time: any }, index) => {
                                    const name = file.name
                                    const time = file?.['time'] ? get_formated_time(new Date(file?.['time']).getTime()) : ''
                                    return (
                                        <div className={`file__details__container ${fileDownloading === name && 'active'}`}>
                                            <div className="file__details__header">
                                                <div className="file__title__wrapper">
                                                    <div className="d-flex align-items-center gap-2">
                                                        <FilequeueSvg color={"#F0F0F0"} />
                                                        <span className="file__title">
                                                            <CustomToolTip title={name} placement="top">
                                                                {(() => {
                                                                    const dotIndex = name.lastIndexOf('.');
                                                                    if (dotIndex === -1) {
                                                                        // No extension case
                                                                        return name.length > 26 ? `${name.substring(0, 23)}...` : name;
                                                                    } else {
                                                                        const baseName = name.substring(0, dotIndex); // Part before the dot
                                                                        const extension = name.substring(dotIndex); // Extension part
                                                                        if (baseName.length > 20) {
                                                                            return `${baseName.substring(0, 13)}...${baseName.substring(baseName.length - 7)}${extension}`;
                                                                        } else {
                                                                            return name;
                                                                        }
                                                                    }
                                                                })()}
                                                            </CustomToolTip>
                                                        </span>
                                                    </div>
                                                    {/* <span className="file__time">{time}</span> */}
                                                </div>
                                            </div>
                                            <button
                                                className="file__queue__btn"
                                                onClick={() => { get_true_twin_file_content_from_datastore(file) }}
                                            >
                                                {fileDownloading === name && <CircularProgress size={48} />}
                                                {!fileDownloading && fileDownloading !== name && <DownloadSvg />}
                                            </button>
                                        </div>
                                    )
                                })}
                            </div>
                        }
                        {downloadFiles?.length === 0 &&
                            <div className="h-100 w-100 align-items-center d-flex">
                                <EmptyPage content_type="file" content={"No Files"} />
                            </div>
                        }
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default FileQueue